import { INSTRUCTION_TITLE_MAX_LENGTH } from '@/components/constants';
import { InstructionPdfForm } from '@/features/ap_payees/components/DocInstructionMenu/types';
import { useTranslation } from '@/i18n';
import { FormInput, Label } from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';
import { Control } from 'react-hook-form';
import styles from '../styles.module.scss';
import { validationRules } from '@/features/ap_payees/components/DocInstructionMenu/Helpers/validationRules';

export type TInstructionTitleProps = {
  control: Control<InstructionPdfForm>;
};
export const InstructionTitle: FC<TInstructionTitleProps> = memo(
  ({ control }) => {
    const { t } = useTranslation();

    const titleRules = useMemo(
      () => ({
        required: {
          value: true,
          message: t('common.validation.required'),
        },
        validate: validationRules.requiredNotAllowEmpty(
          t('common.validation.required')
        ),
        maxLength: {
          value: INSTRUCTION_TITLE_MAX_LENGTH,
          message: t('common.validation.max_length', {
            maxLength: INSTRUCTION_TITLE_MAX_LENGTH,
          }),
        },
      }),
      [t]
    );

    return (
      <div className={styles.row}>
        <div className={styles.label}>
          <Label text={t('export_instruction_pdf_title')} htmlFor='title' />
        </div>
        <div className={styles.content}>
          <FormInput<InstructionPdfForm>
            name='title'
            control={control}
            rules={titleRules}
            inputId='title'
          />
        </div>
      </div>
    );
  }
);
InstructionTitle.displayName = 'InstructionTitle';
